import React, { FC } from 'react'

const CheckIcon: FC = () => (
  <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 6.50009L5.51684 11.7248L5.91768 11.0239C8.06681 7.26593 11.041 4.0449 14.6161 1.60363L15.5 1.00009"
      stroke="#B8B8B8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default CheckIcon
